import { gql } from '@apollo/client';

export const GET_FAVORITE_BUILDINGS = gql`
  query FavoriteBuildings($page: Int!, $pageSize: Int!, $userId: ID!) {
    favoriteBuildings(
      pagination: { pageSize: $pageSize, page: $page }
      sort: "id:asc"
    ) {
      data {
        id
        attributes {
          building {
            data {
              id
              attributes {
                name
                slug
                yearBuilt
                isPreconstruction
                primaryAddress
                buildingStats {
                  minSalePrice
                  maxSalePrice
                  minSaleBeds
                  maxSaleBeds
                }
                neighborhood {
                  data {
                    attributes {
                      slug
                    }
                  }
                }
                mainImage {
                  data {
                    attributes {
                      url
                      formats
                    }
                  }
                }
                favoriteBuildings(
                  filters: { author: { id: { eq: $userId } } }
                ) {
                  data {
                    id
                  }
                }
              }
            }
          }
          alertFrequency
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
        }
      }
    }
  }
`;
